import { EntityTemplateField, getStandardFieldTranslationKey, RequiredAtCreationField } from "./EntityTemplate.types";

export function toEntityTemplateField(racField: RequiredAtCreationField): EntityTemplateField {
    return {
        id: racField.customInputFieldId ?? getStandardFieldTranslationKey(racField.standardFieldIdentifier!),
        standardFieldIdentifier: racField.standardFieldIdentifier,
        customInputFieldId: racField.customInputFieldId,
        customInputFieldType: racField.customInputFieldType,
        customInputFieldName: racField.customInputFieldName,
        customInputFieldDescription: racField.customInputFieldDescription,
        order: racField.stepOrder * 1000 + racField.fieldOrder,
        required: true,
        removeDisabled: false,
        requiredAtCreation: true,
        requiredAtCreationDisabled: false,
        requiredDisabled: false,
        disabled: false,
        defaultValue: racField.defaultValue,
    };
}
